import React from "react";
import { Form } from "react-bootstrap";
import styled from "styled-components";
import TextInput from "./text-input";
import SelectInput from "./custom-selector";
import { InputTypes } from "../../../constants/enums";
import PhoneNumberInput from "./phone-number-input";
import { useTranslation } from "react-i18next";
import Textarea from "./textarea";
import RadioInput from "./radio-input";
import CustomDate from "./custom-date";
import SimpleCheckbox from "./simple-checkbox";
import breakpoints from "../../../constants/breakpoints";

const StyledFormGroup = styled(Form.Group)`
  display: flex;
  flex-direction: ${({ flexDirection }) =>
    flexDirection ? flexDirection : "column"};
  margin-top: 1rem;
  input {
    border-radius: 5px !important;
    background-color: white;
  }
  .form-label {
    width: ${({ flexDirection }) => flexDirection && "51%"};
    margin-top: ${({ flexDirection }) => flexDirection && ".6rem"};
    margin-bottom: 0;

    .required-label {
      color: var(--danger);
    }
  }
  &.year-field {
    > div {
      height: 40px;
      @media (max-width: ${breakpoints.ipadPro}) {
        height: 50px;
      }
    }
  }
`;
const renderInputComponent = (field, validateOnChange, formik) => {
  const values = formik?.values ?? {};
  const setFieldValue = formik?.setFieldValue ?? (() => {});
  const errors = formik?.errors ?? {};
  switch (field.type) {
    case InputTypes.textInput:
      return (
        <TextInput fieldItem={field} validateOnChange={validateOnChange} />
      );

    case InputTypes.mobileNumber:
      return (
        <PhoneNumberInput
          fieldItem={field}
          validateOnChange={validateOnChange}
        />
      );
    case InputTypes.radioButton:
      return (
        <RadioInput
          fieldItem={field}
          value={values[field.name]}
          onChange={(value) => setFieldValue(field.name, value)}
          errorMessage={errors[field.name]}
        />
      );

    case InputTypes.checkbox:
      if (!field.options) {
        return (
          <SimpleCheckbox
            id={field.id}
            checked={values[field.name]}
            onChange={(value) => setFieldValue(field.name, value)}
            label={field.label}
          />
        );
      }
      return (
        <RadioInput
          fieldItem={field}
          value={values[field.name]}
          onChange={(value) => setFieldValue(field.name, value)}
          errorMessage={errors[field.name]}
        />
      );

    case InputTypes.select:
      return (
        <SelectInput fieldItem={field} validateOnChange={validateOnChange} />
      );

    case InputTypes.date:
    case InputTypes.year:
      return (
        <CustomDate
          value={values[field.name]}
          onChange={(value) => setFieldValue(field.name, value)}
          errorMessage={errors[field.name]}
          fieldItem={field}
          validateOnChange={validateOnChange}
          type={field.type}
        />
      );
    case InputTypes.textarea:
      return <Textarea fieldItem={field} validateOnChange={validateOnChange} />;
    default:
      return null;
  }
};
const InputGroup = ({ field, flexDirection, validateOnChange, formik }) => {

  // hooks
  const { t } = useTranslation();
  const isSimpleCheckbox = field.type === InputTypes.checkbox && !field.options;

  return (
    <>
      <StyledFormGroup
        className={`field-container ${field.type === InputTypes.year ? "year-field" : ""}`}
        flexDirection={flexDirection}
      >
        {field?.label && !isSimpleCheckbox && (
          <Form.Label htmlFor={field.id}>
            {t(field.label)}
            {field?.required && <span className="required-label"> *</span>}
          </Form.Label>
        )}
        {renderInputComponent(field, validateOnChange, formik)}
      </StyledFormGroup>
      {field?.errorMessage && validateOnChange && (
        <div className="error-message">{t(field?.errorMessage)}</div>
      )}
    </>
  );
};

export default InputGroup;
